import {updateField} from "vuex-map-fields"
import {getDefaultState} from "./clientTypeState"

export default {
	updateField,
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
	SET_CLIENT_TYPES(state, payload) {
		state.client_types = payload
	},
	SET_CLIENT_TYPE(state, payload) {
		state.client_type = payload
	},
	SET_VALIDATION_ERRORS(state, payload) {
		for (const key in payload) {
			state.validation_client_type[key] = '* '+payload[key][0]
		}
	},
	CLEAR_VALIDATION(state) {
		for (const key in state.validation_client_type) {
			state.validation_client_type[key] = null
		}
	},
}
